import { useCallback, useEffect, useState } from 'react';
import { useVisiblePoll } from './Orders';
import { buildApi, type BuildWorkerWarning } from './buildApi';

const REASONS: Record<string, string> = {
  PROVIDER_REGION_BLOCKED: 'Provider refused this worker’s country',
  PROVIDER_TRANSPORT_FAILED: 'Provider connection failed',
  GOOGLE_LOGIN_REJECTED: 'Google rejected sign-in',
};

export function WorkerWarnings(): JSX.Element | null {
  const [warnings, setWarnings] = useState<BuildWorkerWarning[]>([]);
  const [unavailable, setUnavailable] = useState(false);
  const load = useCallback(async () => {
    try { setWarnings((await buildApi.workerWarnings()).warnings); setUnavailable(false); }
    catch { setUnavailable(true); }
  }, []);
  useEffect(() => { void load(); }, [load]);
  useVisiblePoll(load, 30_000, true);
  if (!warnings.length && !unavailable) return null;
  return <details className="bl-card bl-collapsible">
    <summary className="bl-card-header">
      <h2 className="bl-card-title">Worker warnings</h2>
      <span className="bl-badge bl-badge--warn">{unavailable ? 'History unavailable' : `${new Set(warnings.map((w) => w.worker)).size} workers in history`}</span>
    </summary>
    <p className="bl-hint">Recorded failures remain visible after recovery or worker replacement. Compare repeated failures and their dates when reviewing a worker.</p>
    <div className="bl-table-wrap"><table className="bl-table">
      <thead><tr><th>Worker</th><th>Provider / reason</th><th>Failures</th><th>Accounts / panels</th><th>Orders</th><th>Latest (local time)</th></tr></thead>
      <tbody>{warnings.map((w) => <tr key={`${w.worker}:${w.provider}:${w.code}`}>
        <td>{w.worker}</td><td>{w.provider}: {REASONS[w.code] ?? w.code}</td>
        <td>{w.failures}</td><td>{w.affected_items}</td><td>{w.orders.map((id) => `#${id}`).join(', ')}</td>
        <td title={`First: ${new Date(w.first_at).toLocaleString()}`}>{new Date(w.last_at).toLocaleString()}</td>
      </tr>)}</tbody>
    </table></div>
  </details>;
}
